(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bhi-marble-guide"]) return;
  try {
    
  if (!customElements.get('bhi-marble-guide')) {
    customElements.define('bhi-marble-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const dialog = this.querySelector('dialog');
        if (!dialog || !dialog.showModal) return;
        let opener;
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-bhi-marble-open]');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          opener = link;
          const photo = link.querySelector('img').cloneNode();
          photo.removeAttribute('srcset');
          photo.removeAttribute('sizes');
          photo.src = link.href;
          photo.loading = 'eager';
          dialog.querySelector('[data-marble-photo]').replaceChildren(photo);
          dialog.querySelector('h2').textContent = link.dataset.marbleName;
          dialog.showModal();
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => { if (opener) opener.focus(); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
